var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1967",
    "data-name": "Rettangolo 1967",
    width: 20.269,
    height: 20,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4592",
    "data-name": "Raggruppa 4592",
    transform: "translate(-174 -44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2106",
    "data-name": "Rettangolo 2106",
    width: 24,
    height: 24,
    transform: "translate(174 44)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4591",
    "data-name": "Raggruppa 4591",
    transform: "translate(176 46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1",
    "data-name": "Raggruppa 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_38",
    "data-name": "Tracciato 38",
    d: "M10.135,8.84a4.42,4.42,0,1,0-4.42-4.42,4.42,4.42,0,0,0,4.42,4.42m0,3.559C6.778,12.4,0,14.109,0,17.466A2.534,2.534,0,0,0,2.534,20h15.2a2.534,2.534,0,0,0,2.534-2.534c0-3.357-6.778-5.067-10.135-5.067",
    fill: "currentColor"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c3c7535fcdfbf62b3082527e682eb215.svg";
export { ForwardRef as ReactComponent };